<template>
    <div class="main-div">
        <el-row justify="end" class="headbar">
            <el-col :span="4" />
            <el-col :span="20">
                <el-form
                    :model="args"
                    class="search-form" :inline="true">
                    <el-form-item label="" prop="query" style="width: 250px;">
                        <el-input
                            v-model="args.query"
                            autocomplete="off"
                            placeholder=""
                            clearable
                            maxlength="32"
                            @change="load_data" />
                    </el-form-item>
                    <el-form-item style="width: 46px;">
                        <el-button
                            type="primary"
                            @click="load_data">
                            <el-icon><Search /></el-icon>
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row class="content">
            <el-table
                ref="elTable"
                style="height: 100%;"
                :data="data.slice((page-1)*rspp,page*rspp)"
                :highlight-current-row="true"
                :border="true"
                :row-key="row => row.id"
                :expand-row-keys="expand_row_keys"
                @expand-change="on_expand_change">
                <el-table-column fixed type="index" align="center" />
                <el-table-column
                    v-for="(col, i) in tableCols"
                    :key="i"
                    :fixed="!i"
                    :label="col.label"
                    v-bind="col"
                    header-align="center"
                    :align="col.align" />
                <el-table-column />
                <el-table-column fixed="right" label="" width="120" align="center">
                    <template #default="item">
                        <el-tooltip content="二维码" placement="top">
                            <el-button
                                link
                                type="primary"
                                size="large"
                                @click="gen_qrcode($event, item.row)">
                                <el-icon><Link /></el-icon>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip content="达成率" placement="top">
                            <el-button
                                link
                                type="primary"
                                size="large"
                                @click="open_achievement($event, item.row)">
                                <el-icon><histogram /></el-icon>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip content="编辑" placement="top">
                            <el-button
                                link
                                type="primary"
                                size="large"
                                @click="mod_item($event, item.row)">
                                <el-icon><edit /></el-icon>
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row class="pagebar">
            <el-pagination
                align="center"
                :current-page="page"
                :page-sizes="[10,20,50,999]"
                :page-size="rspp"
                layout="total, sizes, prev, pager, next, jumper"
                :total="data.length"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </el-row>
    </div>
    <DialogMachine ref="DialogMachine" />
    <DialogQRCode ref="DialogQRCode" />
</template>
<script>
import {notify} from '../../assets/js/utils.js';
import {try_catch} from '../../assets/js/async.js';
import {Search, Edit, Histogram, Link} from '@element-plus/icons-vue';
import DialogMachine from './dlg-machine.vue';
import UserStore from '../../stores/user.js';
import DialogQRCode from './dlg-qrcode.vue';

export default {
    name: 'UserList',
    components: {
        Search,
        Link,
        Edit,
        Histogram,
        DialogMachine,
        DialogQRCode,
    },
    data: function() {
        return {
            args: {
                query: '',
            },
            expand_row_keys: [],
            data: [],
            page: 1, // 当前页码
            rspp: 20, // 每页的数据条数
        };
    },
    computed: {
        userstore() {
            return UserStore();
        },
        tableCols() {
            return [
                {
                    prop: 'code',
                    label: '编码',
                    width: 150,
                    align: 'center',
                },
                {
                    prop: 'name',
                    label: '名称',
                    width: 200,
                    align: 'center',
                },
                {
                    prop: 'device',
                    label: '设备',
                    width: 150,
                    align: 'center',
                },
                {
                    prop: 'state_name',
                    label: '状态',
                    width: 80,
                    align: 'center',
                },
            ];
        },
    },
    beforeMount() {
        this.load_data();
    },
    methods: {
        // on_expand_change(row, _children) {
        on_expand_change(row) {
            const key = row.id;
            const index = this.expand_row_keys.indexOf(key);
            if (index < 0) {
                this.expand_row_keys.push(key);
            } else {
                this.expand_row_keys.splice(index, 1);
            }
        },
        async add_item() {
            return await try_catch(async () => {
                const data = await this.$refs.DialogMachine.show({
                    data: { },
                    list: this.data,
                });
                console.debug(data);
                this.load_data();
            });
        },
        async mod_item(_, row) {
            return await try_catch(async () => {
                const data = await this.$refs.DialogMachine.show({
                    data: JSON.parse(JSON.stringify(row)),
                    list: this.data,
                });
                console.debug(data);
                this.load_data();
            });
        },
        async del_item(_, row) {
            return await try_catch(async () => {
                await this.$confirm(`确认要删除"${row.name}"`, '删除提示', {
                    iconClass: 'el-icon-question', // 自定义图标样式
                    confirmButtonText: '确认', // 确认按钮文字更换
                    cancelButtonText: '取消', // 取消按钮文字更换
                    showClose: true, // 是否显示右上角关闭按钮
                    type: 'warning', // 提示类型  success/info/warning/error
                });

                const url = `/api/machines/${row.id}`;
                const res = await this.axios.delete(url);
                if (res.data?.result) {
                    notify('success', '删除成功', 999);
                } else {
                    notify('error', res.data.error);
                }
                this.load_data();
            });
        },
        open_achievement(_, row) {
            this.$router.push({name: 'achievement', params: {mid: row.id}});
        },
        async gen_qrcode(_, row) {
            const route = this.$router.resolve({name: 'achievement_share'});
            const url = `${window.location.origin}/?${route.href}?mid=${row.id}&token=${row.token}`;
            console.log('url:', url);
            const title = row.name;
            const tooltip = '打开连接';
            try {
                await this.$refs.DialogQRCode.show({
                    url,
                    title,
                    tooltip,
                    click: () => { open(url); },
                });
            } catch (exc) {
                if (exc) {
                    console.error(exc);
                }
            }
        },
        async load_data() {
            await try_catch(async () => {
                const url = `/api/machines/`;
                const args = [['q', this.args.query]].reduce((rs, [k, v]) => {
                    if (v) rs[k] = v;
                    return rs;
                }, {});
                const res = await this.axios.get(url, {params: args});
                const data = res.data.data;
                console.log(data);
                data.forEach(item => {
                    item.state_name = [0, '0'].indexOf(item.state) >= 0 ? '冻结' : '活跃';
                });
                this.data.length = 0;
                this.data.push(...data);
            });
        },
        handleSizeChange(val) {
            this.page = 1;
            this.rspp = val;
        },
        // 当前页改变时触发 跳转其他页
        handleCurrentChange(val) {
            this.page = val;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-div{
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    flex-direction: column;
}
.headbar {
}
.footbar {
}
.content {
    height: 100px;
    flex-grow: 1;
}
.search-form {
    text-align: right;
}
.search-form>.el-form-item {
    margin-bottom: 0;
    margin-right: 0;
    width: 150px;
}
</style>
